<template>
  <div class="bg">
    <div class="container h-100 text-center">
      <div class="row h-100">
        <div class="col-6 mx-auto my-auto">
          <div class="title mb-5">
            ระบบแผนที่ภาพถ่ายดาวเทียม <br>
            บริเวณมหาวิทยาลัยพะเยา
          </div>
          <div class="card py-4 px-4">
            <div class="container">
              <img src="../assets/images/logo.png" alt="logo">
              <div class="card-title mt-3 mb-5">เข้าสู่ระบบ</div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <img src="../assets/images/login/icon_user.png" alt="username" class="icon">
                  </span>
                </div>
                <input type="text" class="form-control" v-model="username" placeholder="Username" aria-label="Username">
              </div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <img src="../assets/images/login/icon_key.png" alt="password" class="icon">
                  </span>
                </div>
                <input type="password" class="form-control" v-model="password" placeholder="Password" aria-label="Password">
              </div>
              <div class="text-right">
                <a href="/upmap/backend/" class="purple-text cursor-pointer">หน้าระบบหลังบ้าน</a>
              </div>
              <button type="button" @click="login()" class="btn login-btn my-4">
                <div class="px-5">เข้าสู่ระบบ</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authServices from '../services/auth'
export default {
  data() {
    return {
      username: '',
      password: '',
    }
  },
  methods: {
    async login() {
      const token = await authServices.login(this.username, this.password)
      if(token) {
        this.$router.push("/")
      } else {
        alert('กรุณากรอก Username หรือ Password ให้ถูกต้อง')
      }
    }
  }
}
</script>

<style scoped>
.bg {
  background-image: url('../assets/images/login/background02.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 100vh;
}
.title {
  font-size: 2.3rem;
  color: white;
}
.card-title {
  font-size: 1.3rem;
}
.icon {
  width: 15px;
  height: 15px;
}
.input-group-text {
  background-color: #ddd;
  border: 0;
  border-radius: 18px;
}
.form-control {
  border: 0;
  border-top-right-radius: 18px;
  border-bottom-right-radius: 18px;
  background-color: #ddd;
}
.card {
  border-radius: 18px;
}
.purple-text {
  color: rebeccapurple;
}
.cursor-pointer {
  cursor: pointer !important;
}
.login-btn {
  background: linear-gradient(145deg, rgba(125,48,168,1) 30%, rgba(233,185,13,1) 100%);
  border: 0px;
  border-radius: 18px;
  color: #fff;
}
.login-btn:hover {
  filter: drop-shadow(2px 2px 2px rgba(0,0,0,0.3));
}
</style>